import React from 'react';
import { observer } from 'mobx-react-lite';
import { convertAmount, isMobile, useTranslation } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { winningStore } from '../../store/winningStore';
import { MobileFooterSection } from '../../components/mobileFooterSection';

export const FooterSectionWrapper = observer(({ children }) => {
  const { lastWinAmount } = winningStore;
  const { currencyCode, balance } = userInfoStore;
  const t = useTranslation();

  if (isMobile()) {
    return (
      <MobileFooterSection
        t={t}
        currencyCode={currencyCode}
        balance={balance}
        lastWinAmount={lastWinAmount}
      />
    );
  }

  return (
    <div className='tp-big-btn-wrp'>
      <div className='button-next-text '>
        <p className='button-next-text-inner'>{t('BALANCE')}:</p>
        <span className='button-next-text-inner-span'>{convertAmount(balance)}</span>
      </div>
      {children}
      <div className='button-next-text'>
        <p className='button-next-text-inner'>{t('LAST_WIN')}:</p>
        <span className='button-next-text-inner-span'>
          {!!lastWinAmount && convertAmount(lastWinAmount)}
        </span>
      </div>
    </div>
  );
});
